import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-typewriter',
  templateUrl: './typewriter.component.html',
  styleUrls: ['./typewriter.component.css']
})
export class TypewriterComponent {
  @Input() texts: string[] = [];
  @Input() period: number = 2000;

  private currentIndex: number = 0;
  public currentText: string = '';
  private isDeleting: boolean = false;

  private intervalId: any;

  ngOnInit(): void {
    this.startTyping();
  }

  ngOnDestroy(): void {
    this.stopTyping();
  }

  private startTyping(): void {
    this.intervalId = setInterval(() => {
      this.type();
    }, this.period);
  }

  private stopTyping(): void {
    clearInterval(this.intervalId);
  }

  private type(): void {
    const currentText = this.texts[this.currentIndex];
    if (this.isDeleting) {
      this.currentText = currentText.substring(0, this.currentText.length - 1);
    } else {
      this.currentText = currentText.substring(0, this.currentText.length + 1);
    }

    if (!this.isDeleting && this.currentText === currentText) {
      this.isDeleting = true;
      this.period = 500; // pause before starting to delete
    } else if (this.isDeleting && this.currentText === '') {
      this.isDeleting = false;
      this.currentIndex = (this.currentIndex + 1) % this.texts.length;
      this.period = 2000; // pause before starting to type the next string
    }
  }
}
